import React, { useState } from 'react';
import { FiUser, FiShield, FiSend } from 'react-icons/fi';
import { ROLES, Role, Invite, useClient } from './clientSettingsData';
import SettingsModal from './SettingsModal';

interface Props {
    onClose: () => void;
    onInvite: (invite: Invite) => void;
}

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// UI only: hands the new invitation back to the page, nothing is emailed
const GiveAccessModal: React.FC<Props> = ({ onClose, onInvite }) => {
    const { short } = useClient();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [role, setRole] = useState<Role>('Approver');
    const canSend = name.trim().length > 0 && EMAIL.test(email.trim());

    const send = () => onInvite({ id: `${Date.now()}`, email: email.trim(), role, invited: 'invited just now by you' });

    return <SettingsModal icon={<FiUser />} title={`Give Someone Access to ${short}`} sub="They get an email with a link to set a password" onClose={onClose}
        footer={<button type="button" className="btn-primary" onClick={send} disabled={!canSend}><FiSend /> Send Invitation</button>}>
        <div className="fields">
            <label className="field">
                <span className="label">Full name</span>
                <input value={name} onChange={e => setName(e.target.value)} placeholder="Megan Cole" autoFocus />
            </label>
            <label className="field">
                <span className="label">Work email</span>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="megan.cole@company.com.au" />
            </label>
        </div>

        <div className="label">What can they do?</div>
        {/* spec order for the invite: Admin, Approver, Editor, Viewer */}
        <div className="options" role="radiogroup" aria-label="Role">
            {(['Admin', 'Approver', 'Editor', 'Viewer'] as Role[]).map(r => <button key={r} type="button" role="radio" aria-checked={role === r}
                className={`option${role === r ? ' selected' : ''}`} onClick={() => setRole(r)}>
                <span className="radio" />
                <span className="text"><strong>{r}</strong><span>{ROLES.find(x => x.role === r)?.invite}</span></span>
            </button>)}
        </div>

        <div className="modal-note"><FiShield /> Access here is for {short} only. Two‑factor authentication is required for Admin and Approver.</div>
    </SettingsModal>;
};

export default GiveAccessModal;
